module.exports = __webpack_public_path__ + "assets/img/title-04fc419a.png";